export interface SetApplicantStateByPharmacyProps {
  shiftId: string;
  pharmacistId: string;
  state: ApplicantState;
}
export enum ApplicantState {
  approved = "approved",
  denied = "denied",
}
